import styled from 'styled-components';

import { DatePicker } from 'ui/components/DatePicker';

export const SelectPicker = styled(DatePicker)`
  & .ant-picker-input > input {
    font-size: 12px;
    height: 22px;
  }
  border-radius: 4px;
`;
